import { type Constructor } from '../types';

interface ReadOnlyBehaviors {
  readOnly: boolean;
  setReadOnly(readOnly: boolean): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
function ReadOnlyBehaviors(Base: Constructor<fabric.Object>): any {
  return class extends Base implements ReadOnlyBehaviors {
    __hasReadOnlyBehaviors = true;
    readOnly = false;

    setReadOnly(readOnly: boolean) {
      this.readOnly = readOnly;

      // This ensures that locked objects stay locked/readOnly.
      if (this.locked) {
        readOnly = true;
      }

      this.hasControls = !readOnly;
      this.lockMovementX = readOnly;
      this.lockMovementY = readOnly;
      this.lockScalingX = readOnly;
      this.lockScalingY = readOnly;
      this.lockRotation = readOnly;
    }
  };
}

export default ReadOnlyBehaviors;
